import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from "react";
import { useQueryClient } from "react-query";
import { OAuthToken } from "types/qbank/token";

export type LogOutState = {
  isLoggedIn: false;
};

export type LoggedInState = {
  isLoggedIn: true;
  oAuthToken: OAuthToken;
};
export type AuthState = LogOutState | LoggedInState;

type IProps = PropsWithChildren<{ initialState: AuthState }>;

const AuthContext = createContext<{
  auth: AuthState;
  setAuth: (data: AuthState) => void;
}>(undefined!);

export const AuthProvider = ({ initialState, children }: IProps) => {
  const queryClient = useQueryClient();
  const [auth, setAuthState] = useState<AuthState>(initialState);

  const setAuth = (data: AuthState) => {
    if ("oAuthToken" in data) {
      localStorage.setItem("token", JSON.stringify(data.oAuthToken));
      setAuthState({ isLoggedIn: true, oAuthToken: data.oAuthToken });
    } else {
      queryClient.clear();
      localStorage.removeItem("token");
      setAuthState({ isLoggedIn: false });
    }
  };

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
